<template>
    <div v-loading="pageLoading">
        <el-form
            :model="formData"
            :rules="rules"
            ref="formData"
            label-position="top"
            size="medium"
        >     
            <el-row :gutter="30">
                <!-- <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item label="主题ID">
                        <el-input v-model="formData.id" placeholder="请输入主题ID" maxlength="80" readonly />
                    </el-form-item>
                </el-col>  -->
                <el-col :xs="24" :xl="16">
                    <el-form-item prop="name" label="主题名称">
                        <el-input v-model="formData.name" placeholder="请输入主题名称" maxlength="100" show-word-limit	/>
                    </el-form-item>
                </el-col>
            </el-row> 
            <el-form-item prop="goodsType" label="绑定演出">
                <div class="page-list-box">
                    <el-table
                        :data="dataList"
                        border
                        style="width: 100%"
                        size="small"
                        stripe
                        row-key="id"
                        class="sortable-table"
                    >
                        <el-table-column label="排序" width="48" class-name="sort-handle">
                            <span class="el-icon-sort"></span>
                        </el-table-column>
                        <el-table-column label="城市" prop="cityName"></el-table-column>
                        <el-table-column label="演出ID" prop="id"></el-table-column>
                        <el-table-column label="演出名称" min-width="150" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span class="ellipsis">{{ scope.row.titleStr ||  scope.row.title}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="场地" prop="siteName" min-width="150" show-overflow-tooltip></el-table-column> 
                        <el-table-column label="首场次开演时间" prop="beginShowTime" min-width="150"></el-table-column>                 
                        <el-table-column label="艺人阵容" prop="performer" min-width="150" show-overflow-tooltip></el-table-column>
                        <el-table-column fixed="right" label="操作" width="100">
                            <template slot-scope="scope">
                                <el-button
                                    type="text"
                                    size="small"
                                    v-if="$utils.have('/theme/manger/unBinding')"
                                    icon="el-icon-s-management"
                                    @click="unBinding(scope.row.id)"
                                    >解绑</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div v-if="data" class="page-pagination-box">
                    <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="getData"
                        :current-page.sync="params.pageNo"
                        :page-sizes="$pageSizes"
                        :page-size.sync="params.pageSize"
                        layout="total, sizes, prev, pager, next"
                        :total="data.totalCount || 0"
                    >
                    </el-pagination>
                </div>
            </el-form-item>
            <el-form-item>
                <el-button @click="goBack">返回</el-button>
                <el-button @click="onSubmit" :loading="btnLoading" type="primary" v-if="$utils.have('/theme/manger/save')">保存</el-button>
                <el-button type="warning" @click="toActivityList" v-if="$utils.have('/activity/list')">在演出列表查看所有演出</el-button>
                <el-button type="danger" @click="delShow" v-if="$utils.have('/theme/manger/delete')">删除</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import Sortable from "sortablejs";
export default {
    props: {
        id: {
            type: [Number, String],
            default: null,
        },
    },
    data() {
        return {
            formData: {
                id: '',
                name: ''
            },
            params: {
                pageNo: 1, 
                pageSize: this.$pageSizes[0]
            },
            data: null,
            dataList: null,
            rules: {
                name: [{ required: true, message: "请输入主题名称" }]
            },
            pageLoading: false,
            btnLoading: false,
            redirect: this.$route.query.redirect || '',
        };
    },
    mounted() {
        if (this.id) {
            this.getData();
        }
    },
    methods: {
        // 获取详情
        getData() {
            this.pageLoading = true;
            const data = {...this.params, id: this.id}
            this.$request({
                url: "/theme/manger/detail",
                method: "POST",
                data
            })
                .then((res) => {
                    //处理成功回调
                    const { state, msg, result } = res.data;
                    if (state && state == 1 && result) {
                        this.formData.id = result.id;
                        this.formData.name =  result.name;
                        if(result.activityListVOPage){
                            const {total, size, current, records} = result.activityListVOPage;
                            records.forEach(item=> {
                                if(item.title && item.title.length>40){
                                    item.titleStr = item.title.slice(0,40) + '...'
                                } 
                            })
                            this.dataList = records;
                            this.data = {
                                totalCount: total,
                                pageNo: current,
                                pageSize: size
                            }
                            this.drag();
                        }
                    } else {
                        return this.$message.error(msg || "获取详情失败");
                    }
                })
                .finally(() => {
                    this.pageLoading = false;
                });
        },
        //拖拽排序
        drag(){
            this.$nextTick(() => {
                const el = document.querySelectorAll('.sortable-table > .el-table__body-wrapper > table > tbody')[0];
                Sortable.create(el, {
                    disabled: false, // 拖拽不可用? false 启用
                    ghostClass: 'sortable-ghost', //拖拽样式
                    animation: 150, // 拖拽延时，效果更好看
                    handle: ".sort-handle",
                    onEnd: (e) => { // 拖拽结束时的触发
                        let arr = [...this.dataList]; // 获取表数据
                        arr.splice(e.newIndex, 0, arr.splice(e.oldIndex, 1)[0]); // 数据处理，获取最新的表格数据
                        
                        this.$nextTick(function () {
                            const a1 = (this.dataList.map(a => a.id)).toString();
                            const a2 = (arr.map(a => a.id)).toString();
                            if(a1 != a2){
                                this.dataList = arr;
                                this.updateSort();
                            }
                        })
                    },
                });
            })
        },
        //排序
        updateSort(){
            this.dataList.map( (item,index) => {
                item.sort = index;
            })
			
			this.pageLoading = true;
            this.$request({
                url: '/theme/manger/sort',
                method: "post",
                data: {
                    id: this.id,
                    activityIds: this.dataList.map(v => v.id)
                },
            })
                .then((res) => {
                    //处理成功回调
                    const { state, msg } = res.data;
                    if (state && state == 1) {
                        this.$message.success("排序成功");
						
                    } else {
                        return this.$message.error(msg || "操作失败");
                    }
                })
                .catch(() => {
                    this.$message.error("操作失败,请重试");
                })
                .finally(() => {
                    // this.bannerPoint[index].bannerList = [];
                    // this.getArticleList();
                    this.pageLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getData();
        },
        //表单提交
        onSubmit() {
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    const data = { ...this.formData };
                    this.$request({
                        url: '/theme/manger/save',
                        method: "POST",
                        data,
                    })
                        .then((res) => {
                        //处理成功回调
                        const { state, msg } = res.data;
                        if (state && state == 1) {
                            this.$message.success("保存成功");
                            this.$router.go(-1);
                        } else {
                            return this.$message.error(msg || "操作失败");
                        }
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                }
            });
        },
        // 解绑
        unBinding(id){
            this.$confirm('确认解绑吗？', '提示', {
                type: 'warning',
                center: true,
                closeOnClickModal: false
            }).then(()=> {
                this.$request({
                    url: "/theme/manger/unBinding",
                    method: "POST",
                    params:{
                        activityId: id,
                        themeId: this.id
                    }
                }).then(res=> {
                    const { state, msg, result } = res.data;
                    if (state && state == 1 && result) {
                        this.$message.success("解绑成功");
                        this.getData();
                    } else {
                        return this.$message.error(msg || "解绑失败");
                    }
                })
            }).catch(()=> {})          
        },
        // 删除
        delShow(){
            this.$confirm('删除后所有演出将自动从主题中解绑,是否确定删除该主题?', '提示', {
                confirmButtonText: '确认删除',
                cancelButtonText: '暂不删除',
                type: 'warning',
                center: true,
                closeOnClickModal: false
            }).then(()=> {
                this.$request({
                    url: "/theme/manger/delete",
                    method: "POST",
                    params:{
                        themeId: this.id
                    }
                }).then(res=> {
                    const { state, msg, result } = res.data;
                    if (state && state == 1 && result) {
                        this.$message.success("删除成功");
                        this.$router.go(-1);
                    } else {
                        return this.$message.error(msg || "删除失败");
                    }
                })
            }).catch(()=> {}) 
        },
        toActivityList(){
            this.$router.push({path: '/activityManage/activity/list', query: {searchType: 4, searchValue: this.id}})
        },
        //返回
        goBack() {
            if(this.redirect){
                this.$router.push({
                    path: this.redirect,
                });
            }else{
                this.$router.go(-1);
            }
        },
    },
};
</script>
